import React from 'react';
import { ATMGrid, ATMHeader, ATMTable } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IRequestLandingZone } from 'src/models/request.model';

type IProps = {
  data?: IRequestLandingZone[];
};

const FlightRequestConstructionLandingZone: React.FC<IProps> = ({
  data = [],
}) => {
  return (
    <>
      <ATMHeader size="small" className="text-underline">
        {Lang.TTL_LANDING_ZONE_COORDINATES}
      </ATMHeader>

      <ATMGrid>
        <ATMGrid.Column width={10}>
          <ATMTable>
            <ATMTable.Header>
              <ATMTable.Row>
                <ATMTable.HeaderCell width={6}>
                  {Lang.LBL_LANDING_ZONE_COORDINATE}
                </ATMTable.HeaderCell>
                <ATMTable.HeaderCell width={10}>
                  {Lang.LBL_ATTACHMENTS}
                </ATMTable.HeaderCell>
              </ATMTable.Row>
            </ATMTable.Header>

            <ATMTable.Body>
              {data.map((item, i) => (
                <ATMTable.Row key={`row_${i}`}>
                  <ATMTable.Cell>{item.coordinate}</ATMTable.Cell>
                  <ATMTable.Cell verticalAlign="middle">
                    {item.file && item.file.docName}
                  </ATMTable.Cell>
                </ATMTable.Row>
              ))}
            </ATMTable.Body>
          </ATMTable>
        </ATMGrid.Column>
      </ATMGrid>
    </>
  );
};

export default FlightRequestConstructionLandingZone;
